import { FC } from 'react';
import { LoaderProps } from './loader.types';
import * as S from './loader.styles';

export const Loader: FC<LoaderProps> = ({ variant = 'threeDots', ...props }) => {
  switch (variant) {
    case 'threeDots':
      return (
        <S.DotsContainer {...props}>
          <S.Dot delay={0} />
          <S.Dot delay={0.2} />
          <S.Dot delay={0.4} />
        </S.DotsContainer>
      );
    case 'singleDot':
      return (
        <S.SingleDotContainer {...props}>
          <S.SingleDot />
        </S.SingleDotContainer>
      );
    default:
      return null;
  }
};

Loader.displayName = 'Loader';
